import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { BillingSettings } from "~/modules/billing/api/billingSettings/billingSettingsTypes.ts";
import type { ProjectBillingSettingsPayload } from "~/modules/billing/utils/billingSettingsFormUtils.ts";

const billingSettingsBasePath = "billing-settings";

const projectBillingSettingsPath = (projectId: string) => `projects/${projectId}/${billingSettingsBasePath}`;

export function showProjectBillingSettings(projectId: string): AxiosApiResponsePromise<BillingSettings> {
	return axiosApi.get(projectBillingSettingsPath(projectId));
}

export function updateProjectBillingSettings(
	projectId: string,
	billingSettingsData: ProjectBillingSettingsPayload,
): AxiosApiResponsePromise<void> {
	return axiosApi.put(projectBillingSettingsPath(projectId), billingSettingsData);
}